module.exports = __webpack_public_path__ + "static/media/seedIcons.40449a61.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/SuperUser/img/seedIcons.png
// module id = 989
// module chunks = 0